/* Botão "+" dos cards de produto: adiciona sem sair da página. Vale pra coleção, busca e relacionados. */
(function () {
  if (window.purpleCardAddPronto) return;
  window.purpleCardAddPronto = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-card-add]') || !window.fetch) return;
    e.preventDefault();

    var botao = form.querySelector('button');
    if (!botao || botao.disabled) return;
    var rotulo = botao.getAttribute('aria-label');
    botao.disabled = true;
    botao.setAttribute('aria-busy', 'true');

    function voltar(depois) {
      setTimeout(function () {
        botao.removeAttribute('data-estado');
        botao.removeAttribute('title');
        botao.setAttribute('aria-label', rotulo);
        botao.disabled = false;
      }, depois);
    }

    fetch(form.getAttribute('action') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        botao.removeAttribute('aria-busy');
        botao.setAttribute('data-estado', 'ok');
        botao.setAttribute('aria-label', 'Adicionado ao carrinho');
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        voltar(1800);
      })
      .catch(function (j) {
        botao.removeAttribute('aria-busy');
        // Sem resposta da Shopify (rede): manda o formulário do jeito normal
        if (!j || !j.status) { botao.disabled = false; form.submit(); return; }
        var motivo = j.description || j.message || 'Não deu pra adicionar agora.';
        botao.setAttribute('data-estado', 'erro');
        botao.setAttribute('title', motivo);
        botao.setAttribute('aria-label', motivo);
        voltar(2600);
      });
  });
})();
